import type { ConfiguratorPoolColor } from './configuratorPoolColor.model'
import { z } from 'zod'
import { directusNameTranslationDtoSchema, transformDirectusNameTranslationDtoToDirectusNameTranslation } from '../directus/directusNameTranslationDto.model'

export const configuratorPoolColorDtoSchema = z.object({
  id: z.number(),
  color: z.string(),
  translations: z.array(directusNameTranslationDtoSchema),
})

export type ConfiguratorPoolColorDto = z.infer<typeof configuratorPoolColorDtoSchema>

export function transformConfiguratorPoolColorDtoToConfiguratorPoolColor(
  configuratorPoolColorDto: ConfiguratorPoolColorDto,
): ConfiguratorPoolColor {
  return {
    id: configuratorPoolColorDto.id,
    color: configuratorPoolColorDto.color,
    translations: configuratorPoolColorDto.translations.map(translation => transformDirectusNameTranslationDtoToDirectusNameTranslation(translation)),
  }
}
